export default __webpack_public_path__ + "static/media/vital-alert-tone.fe6ed9b0.mp3";